import { useQuery } from '@tanstack/react-query';
import { ActivationPackService } from '@/services/database/ActivationPackService';
import { PublicActivationDTO } from '@/types/activation/activation-pack';

/**
 * Public (unauthenticated) fetch of the activation microsite data for a pack.
 * `data === null` means not found / private — render a branded 404.
 */
export const usePublicActivationPack = (packId?: string | null) => {
  return useQuery<PublicActivationDTO | null>({
    queryKey: ['public-activation-pack', packId],
    queryFn: () => ActivationPackService.getPublicPack(packId as string),
    enabled: !!packId,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: false,
  });
};
